export default __webpack_public_path__ + "static/media/Lettuce.0770c69e.jpg";